import { ENV_VERIFIED_TRAINER, isBrandActive } from "../../config/environment.config";

export const maintenanceConfigs = {
  default: {
    title: "🛠️ Site en maintenance",
    description: "Merci de votre visite ! Notre site est actuellement en cours de maintenance afin d'améliorer votre expérience. Nous reviendrons très bientôt plus performants et plus simples que jamais. 🔁 En attendant, vous pouvez nous contacter.",
    buttonText: "Contactez-nous",
    buttonLink: isBrandActive(ENV_VERIFIED_TRAINER) ? 'https://verified-trainer.com/contact-us' : `${process.env.REACT_APP_SITE_URI_PROD}/contact`,
    showNavbar: true,
    showAppStoreButtons: false
  },
  simple: {
    title: "Le site Teach'r est en maintenance",
    description: "Le site Teach'r est en maintenance pour quelques minutes ... Nous revenons très vite ! Merci pour votre compréhension.",
    buttonText: "",
    buttonLink: "",
    showNavbar: false,
    showAppStoreButtons: true,
    maintenanceInfo: {
      startDate: "Date et heure du début de la maintenance : {date} à 12h05",
      endDate: "Date et heure de reprise estimée : {date} à 12h45"
    }
  }
}; 